import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getMasterData = async (type, topicKey) => {
  let api;
  if (type) {
    api = APIEndpoint.GET_MASTER_DATA_API + `/${type}/${topicKey}`;
  } else {
    api = APIEndpoint.GET_MASTER_DATA_API + `/${topicKey}`;
  }

  const res = await axiosInstance.get(api);
  return res;
};

export const getCountries = async () => {
  const api = APIEndpoint.GET_COUNTRY_API;
  const res = await axiosInstance.get(api);
  return res;
};
